import VideoJS from 'video.js';

import * as Controls from '../../ui/UIControlsNames';

const TimeDisplay = VideoJS.getComponent('TimeDisplay');

class ASAdCountdown extends TimeDisplay {
    buildCSSClass() {
        return `as-ad-countdown vjs-ad-countdown ${super.buildCSSClass()}`.trim();
    }

    slot(slot) {
        if (slot === undefined) {
            return this.slot_ || undefined;
        }
        this.slot_ = slot || undefined;
    }

    updateContent(event) {
        if (this.slot_) {
            const totalAdDuration = Math.round(this.slot_.getTotalDuration());
            const timeRemaining = totalAdDuration - Math.round(this.slot_.getPlayheadTime());
            this.updateFormattedTime_(timeRemaining);
        }
    }
}

ASAdCountdown.prototype.labelText_ = 'Ad:';
ASAdCountdown.prototype.controlText_ = 'Ad';

VideoJS.registerComponent(Controls.AD_COUNTDOWN, ASAdCountdown);

export default ASAdCountdown;



// WEBPACK FOOTER //
// ./src/player/components/ASAdCountdown.js